import { activityTypeOptions, Options } from 'options';
import { useMembership } from 'services';
import type { ActivityType } from 'types';

export function useAgencyTypeOptions(): Options<ActivityType> {
  const { planning_config } = useMembership();
  return activityTypeOptions.filter(({ value }) => planning_config[value].enabled);
}
